module.exports = __webpack_public_path__ + "img/pl_Ecran 4.994ec682.png";